<template>
  <div>
    <div class="px-16 pt-16">
      <p class="text-zt-xl font-bold mb-8">
        {{ $t("message.publishDocuments.onlySign.title") }}
      </p>
      <div class="mb-6">
        <p class="text-zt-lg font-medium mb-6">
          {{ $t("message.publishDocuments.onlySign.subtitle") }}
        </p>
        <p class="text-zt-base mr-2 mt-2 text-zt-dark-300">
          {{ $t("message.publishDocuments.onlySign.description") }}
        </p>
      </div>
      <div class="items-center mt-8 mb-8">
        <div class="inline-block w-11/12 relative h-32">
          <template v-if="loading">
            <div class="h-32 absolute inset-0 bg-white z-20 -mt-4">
              <div class="border border-1 border-zt-dark-200 h-24">
                <div
                  class="w-full text-center text-format flex justify-center items-center"
                  style="height: 90%"
                >
                  <zt-icon name="box-arrow-top" class="text-zt-xl mr-3" />
                  <span>{{
                    $t("message.publishDocuments.onlySign.uploadingFile")
                  }}</span>
                </div>
                <div class="w-full" style="height: 10%">
                  <div class="progress-line"></div>
                </div>
              </div>
            </div>
          </template>
          <template>
            <template v-if="state.idCarga && state.uploadedFileData.id_carga">
              <div class="zt-input-main w-full flex">
                <div class="px-2 flex items-center justify-center">
                  <zt-icon
                    name="paperclip-2"
                    class="text-zt-xl text-zt-dark-400"
                  />
                </div>
                <div class="w-full relative flex items-center">
                  <div
                    class="w-full rounded border-zt-xs border-solid border-zt-dark-300 py-2"
                  >
                    <zt-chip
                      @click:close="cleanFile(false)"
                      close-icon="close-rounded"
                      square
                      color="primary-100"
                      class="ml-3"
                      closable
                    >
                      {{ state.uploadedFileData.file_name }}
                    </zt-chip>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="flex flex-auto relative justify-start mt-2 ml-12">
                  <span
                    class="text-zt-success text-zt-base"
                    v-html="
                      $sanitize($t('message.publishDocuments.onlySign.success', {
                        quantity:
                          state.uploadedFileData.quantity_documents_uploaded,
                      }))
                    "
                  ></span>
                </div>
                <div class="flex flex-auto relative justify-end mt-2">
                  <span class="text-zt-dark-400 text-zt-xs">{{
                    getFileSize
                  }}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <zt-input-file
                @change="upload"
                outlined
                :label="$t('message.publishDocuments.onlySign.label')"
                prepend-outer-icon="paperclip-2"
                filetypes=".zip"
                :redIfError="error"
              >
                <template slot="message">
                  <span
                    class="text-zt-success text-zt-base"
                    v-if="fileInInput && !error"
                    v-html="$sanitize(successMessage)"
                  ></span>
                  <span v-else class="text-zt-danger text-zt-base">{{
                    error
                  }}</span>
                </template>
              </zt-input-file>
            </template>
          </template>
          <!-- Preview deshabilitado temporalmente -->
            <!-- <div v-show="tag"
          class="preview-file flex text-base text-gray-600 mt-4 cursor-pointer font-semibold"
           @click="openModalPreview()"
        >
          <zt-icon
            class="text-lg no-underline"
            name="eye"
            :class="{ 'animate-spin': isLoading }"
          />
          <p class="ml-3 text-preview">
            Previsualizar archivo
          </p>
        </div> -->
        </div>
         <!-- MODAL PREVIEW DOCUMENTO  -->
    <zt-modal
      class="modal-preview"
      :active="modalPreviewActive"
      @close="modalPreviewActive = false"
      fullscreen
    >
      <template slot="modal-header">
        <div class="p-4 text-center font-bold">
          <h4>
            {{
              $t(
                `message.publishDocuments.onlySign.modalPreviewDocument.title`
              )
            }}
          </h4>
        </div>
      </template>
      <file-visualizer
        :dataPreview="dataPreview"
        :isLoading="isLoading"
        @get-preview="
          (page) => {
            getDocumentPreview(page);
          }
        "
      />
      <template slot="modal-footer">
        <div
          class="flex justify-end items-center text-md p-4 fixed bottom-0 w-full bg-zt-dark-200"
        >
          <zt-button @click="modalPreviewActive = false">{{
            $t(
              `message.publishDocuments.onlySign.modalPreviewDocument.buttonClose`
            )
          }}</zt-button>
        </div>
      </template>
    </zt-modal>
      </div>
    </div>
    <div class="footer p-10 flex justify-end">
      <zt-button v-if="!loading"
        :loader="loaderBtnCancel"
        class="cancel-button text-base font-bold"
        text
         @click="
              fileInInput
                ? (modalConfirmCancelPublish = true)
                : $emit('go-back')
            "
        >{{
          $t("message.publishDocuments.configMassivePublish.btnCancel")
        }}</zt-button
      >
      <zt-button
        class="text-base font-bold ml-2"
        @click="$emit('sign-and-publish', tag)"
        :disabled="validIdCarga"
        >{{
          $t("message.publishDocuments.configMassivePublish.signAndPublish")
        }}</zt-button
      >
    </div>
<!-- MODAL PARA CONFIRMAR CANCELAR LA PUBLICACION -->
     <zt-modal
      :active="modalConfirmCancelPublish"
      @close="modalConfirmCancelPublish = false"
    >
      <template slot="modal-header">
        <div class="p-4 font-semibold text-zt-lg">
          <h4>
            {{ $t(`message.publishDocuments.onlySign.modalCancel.title`) }}
          </h4>
        </div>
      </template>
      <div class="w-full p-6 flex">
        <div class="w-11/12 mx-auto flex py-2">
          <div class="w-1/5 flex justify-center items-center mt-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              fill="none"
              viewBox="0 0 70 70"
            >
              <circle
                cx="35"
                cy="35"
                r="34"
                fill="#fff"
                stroke="#FB8C00"
                stroke-width="2"
              />
              <path
                fill="#FB8C00"
                stroke="#FB8C00"
                d="M34.654 42.776c-.94 0-1.713-.772-1.713-1.713v-18.85c0-.941.772-1.713 1.713-1.713.94 0 1.713.772 1.713 1.713v18.85c0 .944-.753 1.713-1.713 1.713zM34.654 48.203c.94 0 1.713.772 1.713 1.713 0 .94-.772 1.712-1.713 1.712-.94 0-1.713-.772-1.713-1.712 0-.941.772-1.713 1.713-1.713z"
              />
            </svg>
          </div>
          <div
            class="w-4/5 pt-2 pb-4 flex flex-wrap justify-start items-center px-4"
          >
            <span class="w-full text-zt-lg text-zt-dark-400 mt-8 font-normal">
              {{
                $t(`message.publishDocuments.onlySign.modalCancel.description`)
              }}
            </span>
      
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div
          class="zt-modal-footer flex justify-end items-center p-4 bg-zt-dark-100"
        >
          <div class="w-1/4">
         
            <zt-button
              @click="modalConfirmCancelPublish = false"
              class="ml-1 button-cancel-only-text w-11/12 text-base"
            >
              {{ $t(`message.publishDocuments.onlySign.modalCancel.cancel`) }}
            </zt-button>
          </div>
          <div class="w-1/4">
            <zt-button @click="cancelPublish()" class="ml-1 w-11/12 text-base">
              {{ $t(`message.publishDocuments.onlySign.modalCancel.confirm`) }}
            </zt-button>
          </div>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import PublishDocuments from "@/apiClient/PublishDocuments";
import fileVisualizer from "./splitAndCrop/fileVisualizer/fileVisualizer";

export default {
  props: {
    processData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    
  },
  inject: ["state", "mutations"],
  components: {
    fileVisualizer,
  },
  data() {
    return {
      publishDocuments: new PublishDocuments(),
      loading: false,
      file: "",
      error: "",
      successMessage: "",
      fileInInput: false,
      loaderBtnCancel: false,
      modalConfirmCancelPublish: false,
      localUploadData:{},
      isLoading: false,
      dataPreview: {},
      modalPreviewActive: false,
    };
  },
  computed: {
    getFileSize() {
      if (this.state.uploadedFileData.file_size) {
        const size = this.state.uploadedFileData.file_size;
        let parsedSize = 0;
        let message = "";
        if (size < 10000) {
          parsedSize = size / 1024;
          message = this.$t(
          "message.publishDocuments.onlyPublish.sizeKb",
          {
            size: parsedSize.toFixed(2),
          }
        );
        } else {
          parsedSize = size / 1048576;
          message = this.$t(
          "message.publishDocuments.onlyPublish.sizemb",
          {
            size: parsedSize.toFixed(2),
          }
        );
        }
        return message;
      }
    },
    validIdCarga() {
      if (!this.state.idCarga || !this.fileInInput) return true;
    },
    tag(){
      return this.localUploadData.tag? this.localUploadData.tag : this.processData.tag
    }
  },
  methods: {
    async upload(file) {
      if(!file) {
        this.fileInInput = false;
        this.error = '';
        if(this.state.idCarga){
          this.cleanFile(false);
        }
        return;
      }
      this.loading = true;
     
      if (file.size > 7500000000) {
        this.error = this.$t(
          "message.publishDocuments.onlySign.fileSizeExceded"
        );
        this.loading = false;
        return;
      }
      if (!file.type.includes('zip')) {
        this.error = this.$t(
          "message.publishDocuments.onlySign.wrongFiletype"
        );
        this.loading = false;
        return;
      }
      this.file = file;
      this.fileInInput = true;
      const documentType = this.state.documentType.id ? this.state.documentType.id : this.state.documentType 
      let params = {
        file: this.file,
        documentType: this.processData.documentType || documentType,
        period: this.processData.period || this.state.period,
        sendMail: this.processData.sendMail || this.state.sendNotification,
      };
      if (this.state.companyEmail || this.processData.companyEmail ) {
        params = { ...params, companyEmail: this.state.companyEmail || this.processData.companyEmail };
      }
      await this.publishDocuments
        .uploadSignFile(params)
        .then((response) => {
          this.mutations.setIdCarga(response.data.data.tag); 
          this.mutations.setUploadedFileData( response.data.data);
          this.localUploadData = response.data.data 
          this.loading = false;
          this.successMessage = this.$t(
            "message.publishDocuments.onlySign.success",
            { quantity: response.data.data.quantity_documents_uploaded }
          );
        })
        .catch((error) => {
          this.loading = false;
          this.error = this.$t(
            `message.publishDocuments.errors.${error.response.data.codes[0].code}`
          );
        });
    },
    async cleanFile(redirect = true) {
        this.loaderBtnCancel = true;
        await this.publishDocuments
        .deleteFile(this.state.idCarga)
        .then((res) => {
          this.file = "";
          this.mutations.setIdCarga("");
          this.mutations.setUploadedFileData({});
          if(redirect){
          this.$emit("go-back");
          }
        })
        .finally(() => {
          this.loaderBtnCancel = false
          this.loading = false
        });
    },

    async cancelPublish(){
      this.loaderBtnCancel = true;
      if(this.state.idCarga && this.state.uploadedFileData.file_name){
        await this.cleanFile();
      } else{
         await this.upload(null)
      }
      this.$emit('cancel-process');
    },
    openModalPreview() {
      this.getDocumentPreview(1);
    },
    getDocumentPreview(page) {
      this.isLoading = true
     
      let params = {
        tag: this.tag,
        page: page,
      };
      this.publishDocuments
        .getPreviewDocument(params)
        .then((response) => {
          this.dataPreview = response.data.data;
          this.modalPreviewActive = true;
          this.isLoading = false
        })
        .catch((error) => {
           this.isLoading = false
          let errorCode = error.response.data.codes[0].code;
          this.dataPreview = {
            total_pages: 0,
            width: 0,
            height: 0,
            page: "",
          };
          this.$emit("error-on-preview", errorCode);
        });
    },
  },
  watch: {
    async file(val) {
      if (!val) {
        this.error = "";
        if (this.state.idCarga) {
          await this.publishDocuments
            .deleteFile(this.state.idCarga)
            .then((res) => {
              this.file = "";
              this.mutations.setIdCarga("");
              this.mutations.setUploadedFileData({});
            });
        }
      }
    },
  },
  created() {
    this.fileInInput = this.state.idCarga && this.state.uploadedFileData.tag;
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #eeeeee;
}
.text-format {
  font-family: Roboto;
  color: #707070;
}
::v-deep .cancel-button {
  color: #575757 !important;
  background-color: transparent !important;
}
//Progress bar
.progress-line,
.progress-line:before {
  height: 100%;
  width: 100%;
  margin: 0;
}
.progress-line {
  background-color: #cac6e3;
  display: -webkit-flex;
  display: flex;
}
.progress-line:before {
  background-color: #4f41a3;
  content: "";
  -webkit-animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@-webkit-keyframes running-progress {
  0% {
    margin-left: 0px;
    margin-right: 100%;
  }
  50% {
    margin-left: 25%;
    margin-right: 0%;
  }
  100% {
    margin-left: 100%;
    margin-right: 0;
  }
}
@keyframes running-progress {
  0% {
    margin-left: 0px;
    margin-right: 100%;
  }
  50% {
    margin-left: 25%;
    margin-right: 0%;
  }
  100% {
    margin-left: 100%;
    margin-right: 0;
  }
}
//Fake input
.zt-input-main {
  font-size: 1rem;
}
::v-deep .cancel-button {
  color: #575757 !important;
  background-color: transparent !important;
  font-weight: 500;
}

::v-deep .zt-button-disabled {
  color: #b6b6b6 !important;
}

.zt-button {
  font-weight: 500;
  box-shadow: none;
}
.button-cancel-only-text {
  background-color: #f5f5f5 !important;
  color: #949494 !important;
}

</style>
